import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=34694189&scoped=true&"
import script from "./AppForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34694189",
  null
  
)

export default component.exports